import Vue from 'vue';
import router, {DISABLE_FOR_LOGGED, PATH_TO_REDIRECT_IF_LOGGED} from './routers';
import store from './store/store';
import {UPDATE_USER_INFO} from './store/mutationTypes';

import './utils/filters';
import './utils/plugins';
import './utils/injections';
import './utils/social';
import './utils/directives';
import './assets/css/main.scss';
import LoaderComponent from './components/LoaderComponent';
import {
  AVAILABLE_LOCALES,
  DEFAULT_LANGUAGE,
  LANGUAGES,
  MULTILANGUAGE,
  URL_QUERIES,
} from './const';
import VisaicV3Analytics from '@/components/base-components/Analytics/VisaicV3Analytics';
import {
  GET_API_KEY,
  GET_CHANNEL_KEY,
  GET_ALL_PARTICIPANTS,
  GET_CHANNEL_STATIC_DATA,
  GET_GEO_DATA,
  GET_PROFILE,
} from '@/store/actionTypes';
import ErrorReloadScreen from '@/views/ErrorReloadScreen.vue';

import {mapGetters} from 'vuex';
const userSavedLanguage = Vue.$storage.get('interface_language');
const selectedLanguage = MULTILANGUAGE && userSavedLanguage?
  userSavedLanguage : DEFAULT_LANGUAGE;
if (MULTILANGUAGE) {
  Vue.i18n.add(AVAILABLE_LOCALES.EN, LANGUAGES[AVAILABLE_LOCALES.EN]);
  Vue.i18n.add(AVAILABLE_LOCALES.FR, LANGUAGES[AVAILABLE_LOCALES.FR]);
} else {
  Vue.i18n.add(selectedLanguage, LANGUAGES[selectedLanguage]);
}

Vue.i18n.set(selectedLanguage);
Vue.i18n.fallback(DEFAULT_LANGUAGE);

const needParticipantInitRequest = (new URLSearchParams(location.search)).
    has(URL_QUERIES.PARTICIPANT);

new Vue({
  el: '#app',
  store,
  router,
  components: {LoaderComponent, ErrorReloadScreen},
  template: `
    <error-reload-screen :class="{'d-none' : !app}">
      <component v-if="app" :is="app"/>
    </error-reload-screen>`,
  data() {
    return {
      app: false,
    };
  },
  computed: {
    ...mapGetters({
      isLogged: 'isLogged',
    }),
  },
  watch: {
    app() {
      if (this.app) {
        document.getElementById('splash_loader').classList.add('out');
        setTimeout(() => {
          document.getElementById('splash_loader').remove();
        }, 500);
      }
    },
  },
  mounted() {
    store.dispatch(GET_CHANNEL_KEY).then(() => store.dispatch(
        GET_API_KEY,
        {channel_key: Vue.$storage.get('channel_key')},
    )).then(() => Promise.allSettled([
      store.dispatch(GET_CHANNEL_STATIC_DATA).then((hasParticipants) => {
        if (!needParticipantInitRequest && hasParticipants) {
          store.dispatch(GET_ALL_PARTICIPANTS);
        }
      }),
      needParticipantInitRequest && store.dispatch(GET_ALL_PARTICIPANTS),
      store.dispatch(GET_PROFILE).then(() => {
        DISABLE_FOR_LOGGED.includes(router.currentRoute.path) &&
        router.replace(PATH_TO_REDIRECT_IF_LOGGED);
      }).catch(() => store.dispatch(GET_GEO_DATA)),
    ])).catch((err) => {
      store.commit(UPDATE_USER_INFO, null);
      return err;
    }).finally(async () => {
      const newRoutersArr = [
        ...(store.getters.getChannelRoute || []),
        {
          path: '*',
          redirect: '/404',
        },
      ];
      newRoutersArr.forEach((route) => router.addRoute(route));

      this.app = await import('./league/LeagueApp').then((m) => m.default);

      VisaicV3Analytics.init({
        userId: store.state.auth?.user?.id,
        profile: store.state.channel?.settings?.['yare-analytics']?.['yare-analytics-key'],
        apiKey: Vue.$storage.get('api_key'),
      });
    });
  },
});
